export const language = {
    languageName: "简体中文",

    app: {
        name: "歌词滚动姬",
        fullname: "灯里的歌词滚动姬",
    },

    header: {
        home: "主页",
        editor: "编辑",
        synchronizer: "打轴",
        gist: "Github Gist",
        preferences: "设置",
    },

    audio: {
        loadAudio: "加载音频",
        play: "播放",
        pause: "暂停",
        replay5s: "后退 5 秒",
        forward5s: "前进 5 秒",
        resetRate: "重置播放速度",
        error: ["音频错误", "音频请求被用户终止", "音频网络请求错误", "音频解码错误", "浏览器无法支持此音频格式"],
    },

    loadAudio: {
        file: "文件",
        url: "外链",
        loadFile: "点击这里或直接拖放音频到这个页面",
    },

    home: {
        tips: "提示",
        tipForLyricText: "切换到编辑页面，粘贴歌词文本。",
        tipForUploadAudio: "点击左下方按钮，载入音频文件。",
        tipForSynchronizer: "切换到打轴页面，开始制作滚动歌词吧～",
        tipTopLeft: "点击这里可以回到这个帮助页面",
        tipTopRight: "点击这里切换页面",
        tipBottomLeft: "这里可以加载音频，控制播放",
        tipBottomRight: "这里可以调节播放速度",
    },

    editor: {
        metaInfo: "元信息",
        album: "所属专辑",
        title: "歌曲名",
        artist: "艺人名",
        uploadText: "加载文本",
        copyText: "全选复制",
        downloadText: "下载",
        saveToGist: "保存到 Github Gist",
        saveFileName: "文件名",
        utils: "实用工具",
    },

    gist: {
        newTokenTip: "歌词滚动姬使用 Github Token 来存取 Github Gist 上的数据",
        newTokenButton: "生成新的 Github Token",
        newGistTip: "创建一个新的 Gist 仓库或指定一个已存在的 Gist id",
        newGistRepoButton: "创建一个新的 Gist 仓库",
        gistIdPlaceholder: "或指定一个已存在的 Gist id",
        info: "信息",
        clearTokenAndGist: "清除 Github Token 和 Gist id",
    },

    preferences: {
        version: "版本",
        commitHash: "Commit hash",
        updateTime: "更新时间",
        repo: "项目地址",
        help: "关于 & 帮助",
        language: "语言(language)",
        builtInAudio: "使用浏览器内建音频播放器",
        spaceButton: "启用虚拟空格键",
        themeColor: "主题颜色",
        lrcFormat: "歌词输出格式控制",
        fixed: "时间标签小数点",
        leftSpace: "左侧空格",
        rightSpace: "右侧空格",
        clearCache: "清除缓存",
        themeMode: {
            label: "主题模式",
            auto: "跟随系统",
            light: "亮色模式",
            dark: "暗色模式",
        },
    },

    notify: {
        audioLoaded: "音频已载入",
    },
};
